export { default as DocumentViewer } from './DocumentViewer';
